module.exports = __webpack_public_path__ + "static/media/russia.562474ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/russia.svg
// module id = 113
// module chunks = 0